module.exports = __webpack_public_path__ + "media/images/about/a2-36b536f085d45b95b94a8f3e88c293b3.png";